const firebaseConfig = {
    apiKey: "AIzaSyCNLJu8mVLmc9Htx8kECmacj5KKC7w3X6s",
    authDomain: "app-penjualan-8c188.firebaseapp.com",
    databaseURL: "https://app-penjualan-8c188.firebaseio.com",
    projectId: "app-penjualan-8c188",
    storageBucket: "app-penjualan-8c188.appspot.com",
    messagingSenderId: "961576642799",
    appId: "1:961576642799:web:6a709e42b34da0f2f4931a",
    measurementId: "G-DX9TXX289E"
  };

  export default firebaseConfig;